<template>
    <div class="message-item__content--html">
        <div class="content-wrap">
            <p ref="text"
                @click="clickLink"
                :class="{
                    'text': true,
                    'is-expand': isService && isBeyoungLimitLine && isExpand,
                    'is-retract': isService && isBeyoungLimitLine && !isExpand,
                    'acolor': showcolor
                }"
                :style="{background: !isService && color}"
                v-html="content"></p>
            <div
                v-if="isService && isBeyoungLimitLine"
                class="expand-btn"
                @click.stop="toggleExpand">
                {{isExpand ? '查看全部' : '收起'}}
            </div>
        </div>
    </div>
</template>

<script>
    import expand from '../../mixins/expand'
    import { VIEWER_UPDATE } from '@/constants/pub_sub'
    import previewImageMixin from '../../mixins/preview_image'
    export default {
        name: 'MessageContentHtml',
        mixins: [
            expand,
            previewImageMixin
        ],
        props: {
            content: {
                type: String,
                required: true,
                validator (value) {
                    return value.trim() !== ''
                }
            },
            server: {
                type: Object
            }
        },
        computed: {
            showcolor () {
                if (this.server && this.server.from) {
                    if (this.server.from == 'robot' || this.server.from == 'user') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            theme () {
                return this.$eventBus.theme
            },
            color () {
                if (this.theme === 'white') {
                    return this.$store.state.theme.color
                }
                return this.$store.state.lingkeColor
            }
        },
        mounted () {
            const textEl = this.$refs.text
            const imgEls = textEl.querySelectorAll('img')
            imgEls.forEach(img => {
                img.className = img.className + 'viewer'
            })
            this.$nextTick(() => {
                if (this.$eventBus.isDesktop) {
                    this.$eventBus.$emit(VIEWER_UPDATE)
                }
            })
        },
        methods: {
            clickLink (event) {
                event.stopPropagation()
                if (event.target.tagName === 'IMG') {
                    this.previewImage(event,  event.target.src)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../css/content_text";

    .message-item--service {
        .text {
            color: $primary-text-color;
            background-color:  #ffffff;
            box-shadow: $primary-box-shadow;
            @include radius(.25, .5, .5, .5);

            &:active {
                background-color: darken(#ffffff, 7%);
            }

            // 内嵌的html标签样式优化：p、img...
            /deep/ {
                & > * {
                    line-height: initial;
                    max-width: 100% !important;
                }
                p {
                    max-width: 100% !important;
                    & > * {
                        max-width: 100% !important;
                    }
                }
                a{
                    color: #fff;
                    &:hover{
                        color:#fff;
                    }
                }
                img {
                    max-width: 100% !important;
                }
                em {
                    font-style: italic;
                }
                strong {
                    font-weight: bold;
                }
                ol, ul {
                    list-style: initial;
                }
                ul {
                    list-style-type: disc;
                    list-style-position: inside;
                    padding-left: 1em;
                }
                ol {
                    list-style-type: decimal;
                    list-style-position: inside;
                    padding-left: 1em;
                }
            }
        }
        .acolor {
            /deep/ a{
                color: #0068FF;
                &:hover{
                    color:#0068FF;
                }
            }
        }
    }

    .content-wrap {
        position: relative;
    }
</style>

